import {useCallback} from 'react';

import {useDocumentUtils} from '@/components/document/utils';

export const useSetSectionValidity = () => {
  const {store} = useDocumentUtils();

  return useCallback(
    (sectionId: string, isValid: boolean) => {
      store.getState().setSectionValidity(sectionId, isValid);
    },
    [store],
  );
};
